import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'

const namespaced = true;
export default {

  state,
  mutations,
  actions,
  namespaced,

}



// WEBPACK FOOTER //
// ./src/modules/consignment-products-pre-Invoice/index.js